import React from 'react';
import { 
  LuSearch, LuGlobe, LuCircleUser, LuChevronDown, LuMenu, LuX, LuExternalLink,
  LuMapPin, LuHeartHandshake, LuCalendarDays, LuBookOpen, LuTv, LuNewspaper, LuUsers,
  LuMusic, LuGraduationCap, LuSchool, LuHospital, LuLibrary, LuHeartPulse, LuHouse,
  LuFlame, LuHeart, LuSun, LuShare2, LuMailCheck, LuBookMarked, LuArchive, LuChartBar, LuCirclePlay, LuHandHeart,
  LuTent, LuShoppingBag, LuBaby, LuLandmark
} from 'react-icons/lu';
import { GiChurch, GiHolySymbol, GiCrossedSwords } from 'react-icons/gi';
import { FaHeart } from 'react-icons/fa';
import { RiHistoryLine } from 'react-icons/ri';
import logo from '../assets/image.png';

// ==========================================
// SACRED DIOCESE BRAND LOGO ICON (OFFICIAL ASSET)
// ==========================================
export const DioceseLogo = ({ className = "w-7 h-7 object-contain" }) => (
  <img src={logo} alt="CSI Diocese of Malabar Logo" className={className} />
);


// ==========================================
// NAVIGATION & UTILITY ICONS
// ==========================================
export const SearchIcon = ({ className = "w-5 h-5" }) => <LuSearch className={className} />;
export const LanguageIcon = ({ className = "w-4 h-4" }) => <LuGlobe className={className} />;
export const LoginIcon = ({ className = "w-4 h-4" }) => <LuCircleUser className={className} />;
export const DonateHeartIcon = ({ className = "w-4 h-4" }) => <FaHeart className={className} />;
export const ChevronDown = ({ className = "w-3.5 h-3.5" }) => <LuChevronDown className={className} />;
export const MenuIcon = ({ className = "w-6 h-6" }) => <LuMenu className={className} />;
export const CloseIcon = ({ className = "w-6 h-6" }) => <LuX className={className} />;
export const ExternalLinkIcon = ({ className = "w-3.5 h-3.5" }) => <LuExternalLink className={className} />;

// ==========================================
// HOMEPAGE QUICK ACTION ICONS
// ==========================================
export const FindParishIcon = ({ className = "w-6 h-6" }) => <LuMapPin className={className} />;
export const DonateHandIcon = ({ className = "w-6 h-6" }) => <LuHeartHandshake className={className} />;
export const PrayerRequestIcon = ({ className = "w-6 h-6" }) => <LuHandHeart className={className} />;
export const CalendarIcon = ({ className = "w-6 h-6" }) => <LuCalendarDays className={className} />;
export const LiturgyBookIcon = ({ className = "w-6 h-6" }) => <LuBookOpen className={className} />;
export const LiveStreamIcon = ({ className = "w-6 h-6" }) => <LuTv className={className} />;
export const PublicationsIcon = ({ className = "w-6 h-6" }) => <LuNewspaper className={className} />;
export const GroupsIcon = ({ className = "w-6 h-6" }) => <LuUsers className={className} />;

// ==========================================
// MEGA MENU ICONS (ABOUT, CHURCHES, INSTITUTIONS, ETC.)
// ==========================================
export const HistoryIcon = ({ className = "w-5 h-5 text-accent" }) => <RiHistoryLine className={className} />;
export const BishopIcon = ({ className = "w-5 h-5 text-accent" }) => <GiHolySymbol className={className} />;
export const CouncilIcon = ({ className = "w-5 h-5 text-accent" }) => <LuUsers className={className} />;
export const GovernanceIcon = ({ className = "w-5 h-5 text-accent" }) => <GiCrossedSwords className={className} />;
export const ConstitutionIcon = ({ className = "w-5 h-5 text-accent" }) => <LuBookOpen className={className} />;
export const FormerBishopsIcon = ({ className = "w-5 h-5 text-accent" }) => <GiChurch className={className} />;

export const CathedralIcon = ({ className = "w-5 h-5 text-accent" }) => <GiChurch className={className} />;
export const ParishDirectoryIcon = ({ className = "w-5 h-5 text-accent" }) => <LuMapPin className={className} />;
export const WorshipTimingsIcon = ({ className = "w-5 h-5 text-accent" }) => <LuCalendarDays className={className} />;
export const DeaneryIcon = ({ className = "w-5 h-5 text-accent" }) => <LuMapPin className={className} />;
export const PriestDirectoryIcon = ({ className = "w-5 h-5 text-accent" }) => <LuCircleUser className={className} />;
export const ChoirIcon = ({ className = "w-5 h-5 text-accent" }) => <LuMusic className={className} />;

export const CollegeIcon = ({ className = "w-5 h-5 text-accent" }) => <LuGraduationCap className={className} />;
export const SchoolIcon = ({ className = "w-5 h-5 text-accent" }) => <LuSchool className={className} />;
export const HospitalIcon = ({ className = "w-5 h-5 text-accent" }) => <LuHospital className={className} />;
export const RetreatCenterIcon = ({ className = "w-5 h-5 text-accent" }) => <LuTent className={className} />;
export const BookShopIcon = ({ className = "w-5 h-5 text-accent" }) => <LuShoppingBag className={className} />;
export const ChildCareIcon = ({ className = "w-5 h-5 text-accent" }) => <LuBaby className={className} />;
export const SocialBoardIcon = ({ className = "w-5 h-5 text-accent" }) => <LuLandmark className={className} />;
// kept for backward compat
export const SeminaryIcon = ({ className = "w-5 h-5 text-accent" }) => <LuLibrary className={className} />;
export const SpecialCareIcon = ({ className = "w-5 h-5 text-accent" }) => <LuHeartPulse className={className} />;
export const HostelIcon = ({ className = "w-5 h-5 text-accent" }) => <LuHouse className={className} />;

export const YouthIcon = ({ className = "w-5 h-5 text-accent" }) => <LuFlame className={className} />;
export const WomenFellowshipIcon = ({ className = "w-5 h-5 text-accent" }) => <LuHeart className={className} />;
export const SundaySchoolIcon = ({ className = "w-5 h-5 text-accent" }) => <LuSun className={className} />;
export const MissionIcon = ({ className = "w-5 h-5 text-accent" }) => <LuShare2 className={className} />;

export const MagazineIcon = ({ className = "w-5 h-5 text-accent" }) => <LuNewspaper className={className} />;
export const PastoralLetterIcon = ({ className = "w-5 h-5 text-accent" }) => <LuMailCheck className={className} />;
export const LiturgyIcon = ({ className = "w-5 h-5 text-accent" }) => <LuBookMarked className={className} />;
export const ArchivesIcon = ({ className = "w-5 h-5 text-accent" }) => <LuArchive className={className} />;
export const ReportsIcon = ({ className = "w-5 h-5 text-accent" }) => <LuChartBar className={className} />;
export const MultimediaIcon = ({ className = "w-5 h-5 text-accent" }) => <LuCirclePlay className={className} />;

